<ng-template #showModal>
  <div id="showDevicePopup" class="card showDevicePopup" dir={{direction}}>
    <div id="showDevicePopupBody" class="popup-body">
      <div id="showDevicePopupHeader" class="modal-header">
        <div id="showDevicePopupClose" (click)="dismiss()" class="close_icon">
          <img class="modal-close-icon" alt="close icon" />
        </div>
      </div>
      <div id="showDeviceModalBody" class="modal-body">
        <h2><span i18n="@@showon-device.title.showondevice">Show on Device?</span></h2>
        <div class="card_desc">
          <span i18n="@@showon-device.title.showondevice-text">Do you want to show this content group on device?</span>
        </div>
      </div>
      <div id="showDevicePopupFooter" class="modal-footer card-footer">
        <button type="button" (click)="closeShowOnDevice()" class="btn btn-outline-primary gtmCancelDltContGrp">
          <span i18n="@@showon-device.footer.no">No</span>
        </button>
        <button type="button" class="btn btn-primary gtmDeleteContGrp btn-yes" (click)="ShowOnDeviceButton()">
          <span i18n="@@showon-device.footer.yes">Yes, show on device</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>